function SessionPropertiesEvent() {
}

module.exports = SessionPropertiesEvent;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/session-properties-event.js
// module id = 531
// module chunks = 1